export default {
    name: 'SecureCloud',
	singular: 'Enhet',
	icon: 'cloud',
  	ownView: 'SecureCloud',
	slug: 'secure-cloud',
	isCustom: true,
	access: ['superadmin']
}